import hourglassGif from "../../asstes/icons/chemistry/hourglass.gif";

export default function StepPopup({ popup }) {
  if (!popup) return null;

  const color =
    popup.type === "success"
      ? "bg-green-100 text-green-700"
      : popup.type === "error"
      ? "bg-red-100 text-red-700"
      : "bg-blue-100 text-blue-700";

  // Check if this popup message is the "reaction in progress" type
  const isReactionTimer =
    typeof popup.message === "string" &&
    (popup.message.includes("Reaction in progress") ||
      popup.message.includes("Reaction in"));

  return (
    <div
      className={`absolute top-6 px-4 py-2 rounded-lg shadow ${color} transition-all duration-700 ease-in-out text-center`}
    >
      {isReactionTimer && (
        <img
          src={hourglassGif}
          alt="Reaction in progress"
          className="w-5 h-5 animate-pulse"
        />
      )}
      {/* <span>{popup.message.replace("⏳ ", "")}</span> */}
      <span
        dangerouslySetInnerHTML={{
          __html: popup.message.replace("⏳ ", ""),
        }}
        className="font-medium"
      ></span>
    </div>
  );
}
